import { privateRequest, type ApiResponse } from "../axios";
import { saveAsExcelFile } from "../excelService/excelSevice";

const ENDPOINTS = {
  GET_CRM_FORM: "api/CRM/GetCRMForms",
  FORM_STATS: "api/CRM/FormStats",
  EMAIL_FORM: "api/DynamicForm/EmailFormAnswerReport",
  FORM_DELETE: "api/DynamicForm/Form",
  VISIT_FORM: "api/DynamicForm/Answers",
  EXCEL: "api/DynamicForm/Answers/ExportToExcel",
  CREATE_FORM: "api/CRM/CreateForm",
  DYANAMIC_GET_FORM: "api/DynamicForm/GetForms",
  INTERCOM: "api/IntercomGroupWithOwners",
  DYNAMIC_FORM_BY_ID: "api/DynamicForm/Form?id=",
  CREATE_DYNAMIC_FORM: "api/DynamicForm/CreateForm",
  COMPANY_MEMBER: "api/CompanyMembers",
  SUBMIT_ANSWER: "api/DynamicForm/SubmitAnswers",
  FORM_ANSWER: "api/DynamicForm/FormAnswer?formFilledId=" 
}

const getCrmForm = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.GET_CRM_FORM
  );
  return res.data;
}
const getFormStats = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.FORM_STATS}?formId=${data.formId}`
  );
  return res.data;
}
const emailFormAnswerReport = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.EMAIL_FORM}?formId=${data.formId}&emailIds=${data.email}`
  );
  return res.data;
}

const deleteForm = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.delete<ApiResponse<any>>(
    `${ENDPOINTS.FORM_DELETE}?formId=${data.formId}`
  );
  return res.data;
}

const getCompanyMembers = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.COMPANY_MEMBER}?From=${data.from}&To=${data.to}&text=${data.text}`
  )
  return res.data;
}

const getVisitForm = async (data: any): Promise<ApiResponse<any>> => {

  const query = new URLSearchParams({
    formId: data.formId,
    startDate: data.startDate,
    endDate: data.endDate,
    submittedByUserId: data.submittedByUserId,
    leadId: data.leadId,
    sortBy: data.sortBy,
    userId: data.userId,
    search: data.search || ""
  }).toString();

  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.VISIT_FORM}?${query}`
  );

  return res.data;
};

const exportExcel = async (data: any) => {
  const query = new URLSearchParams({
    formId: data.formId,
    startDate: data.startDate,
    endDate: data.endDate,
    submittedByUserId: data.submittedByUserId,
    leadId: data.leadId,
    sortBy: data.sortBy,
    userId: data.userId,
    search: data.search || ""
  }).toString();

  const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.EXCEL}?${query}`, { responseType: "arraybuffer" });
  return res;
};

const createForm = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.CREATE_FORM, data
  );
  return res.data;
}
const getDynamicForm = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.DYANAMIC_GET_FORM
  )
  return res.data;
}

const getIntercomWithOwner = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.INTERCOM}?PageSize=${data.pageSize}&Rownumber=${data.rowNumber}`
  )
  return res.data;
}
const getDyanmicFromById = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.DYNAMIC_FORM_BY_ID}${data.Id}`
  );
  return res.data;
}
const createDynamicForm = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.CREATE_DYNAMIC_FORM, data
  );
  return res.data;
}

const submitAnswer = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.SUBMIT_ANSWER, data
  );
  return res.data;
}

const formAnswer = async (data: any): Promise<ApiResponse<any>> => { 
  const res = await privateRequest.get<ApiResponse<any>>( 
    `${ENDPOINTS.FORM_ANSWER}${data.formFilledId}`
  ); 
  return res.data;    
  
}

const visitFormService = {
  getCrmForm,
  getFormStats,
  emailFormAnswerReport,
  deleteForm,
  getVisitForm,
  exportExcel,
  createForm,
  getDynamicForm,
  getIntercomWithOwner,
  getDyanmicFromById,
  createDynamicForm,
  getCompanyMembers,
  submitAnswer,
  formAnswer
}

export default visitFormService;
